function setWithExpiry(key, value, ttl) {
    const now = new Date();
    const item = {
        value: value,
        expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
};

function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    // if the item doesn't exist, return null
    if (!itemStr) {
        return false;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        localStorage.removeItem(key);
        return false;
    }
    return item.value;
};

const setNetsuitData = () => {
    if(!window.location.search) return;
    
    const params = new URLSearchParams(window.location.search);
    const source = params.get("source") || params.get("utm_source");
    const medium = params.get("medium") || params.get("utm_medium");
    const campaign = params.get("campaign") || params.get("utm_campaign");
    
    if(!source || !medium || !campaign) return;
    
    const data = {
        source: source,
        medium: medium,
        campaign: campaign
    };

    const oneDay = 24 * 60 * 60 * 1000;
    setWithExpiry("netsuite", JSON.stringify(data), oneDay);
}

const fillNetsuiteIframe = () => {
    const netsuite = getWithExpiry("netsuite");
    if(!netsuite) return;

    const data = JSON.parse(netsuite);
    const iframe = document.querySelector("#netsuite");
    if(!iframe) return;

    iframe.src += `&utm_source=${data.source}&utm_medium=${data.medium}&utm_campaign=${data.campaign}`;
}

document.addEventListener("DOMContentLoaded", function() {
    setNetsuitData();
    fillNetsuiteIframe();
});
